import { Block } from 'framework7-react';
import React, { FC } from 'react';
import styles from './EvaluationDetailsStyle.module.css';
import { PopupPageTemplate } from '@/components/uiParts/Template/PopupPageTemplate/PopupPageTemplate';

export const EvaluationDetails: FC = () => {
  return (
    <PopupPageTemplate
      pageName="evaluation"
      title={'安全運転スコアの算出基準と\nアラートの判定基準'}
    >
      <Block className={styles.container}>
        <h3 className={styles.sectionTitle}>安全運転スコアの仕組み</h3>

        <p className={styles.body}>
          当社の安全運転スコアは、お客さまの
          <span className={styles.em}>走行距離</span>に対する
          <span className={styles.em}>危険挙動の発生頻度</span>
          をもとに、安全運転の度合いを数値化したものです。
        </p>

        {/* 例えば… の青カード */}
        <div
          className={styles.exampleCard}
          role="group"
          aria-labelledby="ex-title"
        >
          <p id="ex-title" className={styles.exampleTitle}>
            例えば…
          </p>
          <ul className={styles.caseList}>
            <li className={styles.case}>
              <span className={styles.caseNum} aria-label="例1">
                1
              </span>
              <div className={styles.caseText}>
                <p>
                  <span className={styles.km}>100km</span>走行して
                  <span className={styles.count}>1回</span>
                  の急ブレーキをした場合
                </p>
                <p className={styles.result}>
                  <span className={styles.arrow} aria-hidden>
                    →
                  </span>
                  ブレーキ発生頻度、100kmあたり1回
                </p>
              </div>
            </li>

            <li className={styles.case}>
              <span className={styles.caseNum} aria-label="例2">
                2
              </span>
              <div className={styles.caseText}>
                <p>
                  <span className={styles.km}>10km</span>走行して
                  <span className={styles.count}>1回</span>
                  の急ブレーキをした場合
                </p>
                <p className={styles.result}>
                  <span className={styles.arrow} aria-hidden>
                    →
                  </span>
                  ブレーキ発生頻度、100kmあたり10回
                </p>
              </div>
            </li>
          </ul>
        </div>

        <p className={styles.body}>
          同じ急ブレーキの回数でも、<span className={styles.em}>走行距離</span>
          に対する
          <span className={styles.em}>危険挙動の発生頻度</span>
          が高いほど、より危険な運転とみなされます。
        </p>

        <p className={styles.body}>
          また、安全運転スコアは「1回の危険挙動で何点減点」という方式ではなく、
          運転特性計測期間における
          <span className={styles.em}>危険挙動の発生頻度</span>
          をもとに算出する仕組みとなっています。
        </p>

        <p className={styles.body}>
          一度低いスコアをとったとしても、その後の運転で安全運転を心がけていただければ、
          安全運転スコアは改善していきます。ご安心ください。
        </p>

        <h3 className={styles.sectionTitle}>アラートの判定基準</h3>
        <h4>判定条件は以下の通りです。</h4>
        <p>
          速度超過：一定区間の平均速度が道路種別ごとに設定された速度基準を超えた場合
        </p>
        <p>
          急アクセル・急ブレーキ :
          「1秒間に約10km/ｈ以上の加速・減速」を基準として急アクセル・急ブレーキを検知した場合
        </p>
      </Block>
    </PopupPageTemplate>
  );
};
